var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ai-catalog-item-field',{attrs:{"title":_vm.s__('AICatalog|Visibility')}},[_c('div',{staticClass:"gl-text-subtle"},[_vm._v("\n    "+_vm._s(_vm.visibilityDescription)+"\n  ")]),_vm._v(" "),_c('gl-badge',{staticClass:"gl-mt-3",attrs:{"icon":_vm.badgeIcon,"variant":_vm.badgeVariant}},[_vm._v("\n    "+_vm._s(_vm.badgeLabel)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }